'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Directive handling the visibility state of a container.
 * Used as information bus for children directive which need to know when they are displayed
 * ( to allow correct size computing or lazy initialisation for example )
 *
 * @see autosize.js
 */
ngModule.directive("hideableContainer", function (EventBus, directiveUtils) {
  return {
    restrict: "AC",
    controller: function controller($scope, $element) {
      var ctrl = this,
        parentCtrl = directiveUtils.getParentController($element, "hideableContainer"),
        containerVisible = true,
        parentVisible = true;
      EventBus.makeBus(ctrl);
      var isVisible = function isVisible() {
        return parentVisible && containerVisible;
      };
      var onVisibilityChange = function onVisibilityChange() {
        ctrl.trigger("visibility:change", isVisible());
      };
      if (parentCtrl) {
        parentVisible = parentCtrl.isVisible();
        var onParentVisibilityChange = function onParentVisibilityChange(newParentVisibility) {
          var wasVisible = isVisible();
          parentVisible = newParentVisibility;
          var nowVisible = isVisible();
          if (wasVisible !== nowVisible) {
            onVisibilityChange();
          }
        };
        parentCtrl.on("visibility:change", onParentVisibilityChange);
      }
      ctrl.setVisible = function (visible) {
        var wasVisible = isVisible();
        containerVisible = visible;
        var nowVisible = isVisible();
        if (wasVisible !== nowVisible) {
          onVisibilityChange();
        }
      };
      ctrl.isVisible = function () {
        return isVisible();
      };
      ctrl.onVisibilityChange = function (handler) {
        ctrl.on("visibility:change", handler);
        return function () {
          ctrl.off("visibility:change", handler);
        };
      };
      $scope.$on("$destroy", function () {
        ctrl.off();
        if (parentCtrl) {
          parentCtrl.off("visibility:change", onParentVisibilityChange);
        }
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/autosizing/hideableContainer.js
// module id = 2919
// module chunks = 13